import React from 'react';
import styled from 'styled-components';
import Card from '@/components/Card';
import TextComponent from '@/components/TextComponent';
import { SettlementListFilters } from '@/apis/settlement/interface';
import useSettlementQuery from '@/hooks/settlement/useSettlementQuery';

interface Props {
  filter: SettlementListFilters;
}

const DeliveryDetail = (props: Props) => {
  const { settlementCountByTypeQuery } = useSettlementQuery();
  const { data: settlement } = settlementCountByTypeQuery(props.filter);
  const deliveryCount = (settlement?.delivery || 0) + (settlement?.quick || 0);

  return (
    <Card>
      <CardBody>
        <Method>
          <MethodItem>
            <MethodLabel>배달</MethodLabel>
            <MethodCount>{deliveryCount}건</MethodCount>
          </MethodItem>
          <MethodItem>
            <MethodLabel>택배</MethodLabel>
            <MethodCount>{settlement?.post || 0}건</MethodCount>
          </MethodItem>
          {/* 레거시 문제로 일단 예외하기로함
            <MethodItem>
              <MethodLabel>하루</MethodLabel>
              <MethodCount>{settlement?.overnight || 0}건</MethodCount>
            </MethodItem>
            */}
          <MethodItem>
            <MethodLabel>기타</MethodLabel>
            <MethodCount>{settlement?.dawn || 0}건</MethodCount>
          </MethodItem>
        </Method>

        <Total>
          <TotalText>총 {settlement?.totalCount}건</TotalText>
        </Total>
      </CardBody>
    </Card>
  );
};

export default DeliveryDetail;

const CardBody = styled.div`
  width: 320px;
  height: 100%;
  display: flex;
  flex-flow: column;
  padding: 25px 28px 0;
`;

const Method = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50%;
  padding: 0 15px;
`;

const MethodItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

const MethodLabel = styled(TextComponent)`
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #595959;
`;

const MethodCount = styled(TextComponent)`
  font-size: 22px;
  font-weight: bold;
`;

const Total = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  padding: 20px 0;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #d8d8d8;
`;

const TotalText = styled(TextComponent)`
  font-size: 30px;
  font-weight: 600;
`;
